import type { ComponentType, LazyExoticComponent, ReactNode } from 'react';

interface AppLayoutComposerProps {
  nested?: LazyExoticComponent<ComponentType<{ children: ReactNode }>>[];
  children: ReactNode;
}

/**
 * Composes multiple layouts in a nested hierarchy
 *
 * Example: AppLayoutComposer({ nested: [DashboardLayout, CompanyLayout], children: <Page /> })
 * Renders: <DashboardLayout><CompanyLayout><Page /></CompanyLayout></DashboardLayout>
 *
 * @param nested - Array of lazy-loaded layout components to nest
 * @param children - The content to wrap with layouts
 * @returns The composed layout hierarchy
 */
export function AppLayoutComposer({ nested, children }: AppLayoutComposerProps) {
  if (!nested || nested.length === 0) {
    return <>{children}</>;
  }

  return nested.reduceRight((child, Layout) => <Layout>{child}</Layout>, children);
}
